import { useDecision } from '@optimizely/react-sdk'
import { RoutesPaths } from '@space-shell/core/router'
import { useMatch } from 'react-router-dom'

export function useSalesPageConfig() {
  const [{ enabled: isClubBasicEnabled }] = useDecision('mex_enable_sales_page_basic_experience')
  const isSalesPage = useMatch(`${RoutesPaths.HOME}${RoutesPaths.SALES}`)
  const canShowProductPageHeader = Boolean(isSalesPage) && isClubBasicEnabled

  return {
    isClubBasicEnabled,
    canShowProductPageHeader
  } as const
}
